import { MapState } from 'src/app/interfaces/map.interface';
import { Coords, SearchAggregationBucket } from 'src/app/swagger-api';
import { SearchResultAggregation } from 'src/app/swagger-api/model/searchResultAggregation';
import { AggregationKey } from '../../map.interfaces';
import { MapValues } from '../../map.values';
import { DiametricalCoordsCreatorFactory } from '../factories/diametrical-coords-creator.factory';
import { getSearchAggregationDecoratedResult } from './decorators.helpers';
import { SharedResponseCoordsProcessorDecorator } from './shared-response-coords-processor.decorator';
import { AggregationProcessorType } from './shared-response-processor.decorator';

export class AggregationResponseCoordsProcessorDecorator extends SharedResponseCoordsProcessorDecorator<SearchResultAggregation> {
  public constructor(entity: AggregationProcessorType, state: MapState) {
    super(entity, state);
  }

  protected override getDecoratedItemsCoords(results: SearchResultAggregation[]): SearchResultAggregation[] {
    const mapIndividualRolesKeys: string[] = MapValues.mapStatisticsSearchIndividualRolesKeys;
    const maxItemsCount: number = this.getMaxItemsCount(results);
    if (mapIndividualRolesKeys.includes(results[0].aggregated_entities[0])) {
      const points: Coords[] = DiametricalCoordsCreatorFactory.createCoordsList({
        center: (results[0].buckets[0].aggregation_key as AggregationKey).center_coordinates,
        radius: this.getRadius({
          pinsCount: results.length,
          coords: (results[0].buckets[0].aggregation_key as AggregationKey).center_coordinates,
          aggregatedItemsCount: maxItemsCount,
        }),
        count: results.length,
        zoom: this.state.zoom,
      });
      return super.getDecoratedItemsCoords(
        results.map((item: SearchResultAggregation, index: number) =>
          getSearchAggregationDecoratedResult(item, 0, points[index]),
        ),
      );
    }
    return super.getDecoratedItemsCoords(results);
  }

  protected getMaxItemsCount(buckets: SearchResultAggregation[]): number {
    const aggregationCount: number[] = [];
    buckets.forEach((bucket: SearchResultAggregation) => {
      bucket.buckets.forEach((aggregationBucket: SearchAggregationBucket) => {
        aggregationCount.push(aggregationBucket.aggregated_items_count);
      });
    });
    return Math.max(...aggregationCount);
  }

  protected override groupItemsByCoords(results: SearchResultAggregation[]): Map<string, SearchResultAggregation[]> {
    return super.groupItemsByCoords(
      results,
      (_result: SearchResultAggregation, nestedObject: SearchAggregationBucket) =>
        `${(nestedObject.aggregation_key as AggregationKey).center_coordinates.lat}_${
          (nestedObject.aggregation_key as AggregationKey).center_coordinates.lon
        }`,
      (result: SearchResultAggregation, nestedObject?: SearchAggregationBucket) => ({
        ...result,
        buckets: [nestedObject],
      }),
      'buckets',
    );
  }
}
